import type {
    TypeArticleCardDetailed,
    TypeArticleTemplateDetailed,
    TypeCarouselDetailed,
    TypeLayoutDetailed,
    TypeLinkDetailed,
    TypeMenuTemplateDetailed,
    TypeProductListTemplateDetailed,
    TypeSectionTemplateDetailed,
    TypeShortcutsDetailed,
    TypeStandardTemplateDetailed
} from 'types/autogen/contentful';
import type { PageActionModel } from 'components/shared/Routing/PageAction';
import { useIsPreview } from 'components/pages/Contentful/context/PreviewContext';

export function navigationLinkToPageAction(navigationLink?: TypeLinkDetailed | undefined): PageActionModel | undefined {
    if (!navigationLink) return undefined;

    if (navigationLink.fields.linkToItem && typeof navigationLink.fields.linkToItem === 'object')
        return navigationLink.fields.linkToItem as unknown as PageActionModel;

    if (navigationLink.fields.slug && typeof navigationLink.fields.slug === 'object')
        return navigationLink.fields.slug as unknown as PageActionModel;

    if (navigationLink.fields.externalUrl && typeof navigationLink.fields.externalUrl === 'object')
        return navigationLink.fields.externalUrl as unknown as PageActionModel;

    if (
        navigationLink.fields.linkToFile &&
        typeof navigationLink.fields.linkToFile === 'object' &&
        navigationLink.fields.linkToFile.fields.file?.url
    ) {
        return {
            action: {
                url: navigationLink.fields.linkToFile.fields.file?.url,
                noFollow: false,
                openInNewWindow: true,
                $type: 'ExternalLinkAction'
            },
            $type: 'LinkActionType'
        } as PageActionModel;
    }

    return undefined;
}

// Type constraint to ensure T has the fields.isPublished property
type PublishableEntry = {
    fields?: {
        isPublished?: boolean;
    };
};

export function filterPublishedFields<T extends PublishableEntry>(entries?: T[]): T[] {
    const isPreview = useIsPreview();

    if (!entries) return [];

    return entries.filter((x) => x?.fields?.isPublished || isPreview.isPreviewMode);
}
